<wk-icon-funnel-sprite-pds3 />
<wk-icon-filled-funnel-sprite-pds3 />

@let _filter = filter();
@if (_filter) {
    <div class="wk-cf__container">
        <div class="wk-cf__header">
            @if (addLabel()) {
                <div class="wk-cf__header__label">{{ label() ?? filter()?.definition.label | wkTranslate }}</div>
            }
            <button class="wk-cf__trigger" [id]="popupTargetId">
                <icon-pds3 [name]="`wk-icon-${_filter.isActive() ? 'filled-' : ''}funnel`" />
            </button>
        </div>
        <wk-filter-pills [filterName]="filterName()" />
    </div>
    <portal-pds3 elementId="wk-app__root">
        <popup-pds3
            flowClass="wk-cf__popup"
            [isOpen]="isPopupOpen()"
            [targetSelector]="`#${popupTargetId}`"
            [placementOptions]="popupPlacement"
            (userRequest)="onPopupRequest($event)"
        >
            <div class="wk-cf__popover">
                @if (isMultiSelection()) {
                    <div class="wk-cf__popover__header">
                        <div class="wk-cf__popover__actions">
                            <div class="wk-cf__popover__actions-link wk-cf__popover__actions-select-all" (click)="onSelectAll()">
                                {{ "Settings.SelectAll" | translate }}
                            </div>
                            <div class="wk-rolesOptions-selection-count">
                                ( {{ filterSelectionLength() }}
                                {{
                                    (filterSelectionLength() > 1 ? "AllView.MultipleCardSelectedTitle" : "AllView.SingleCardSelectedTitle")
                                        | translate
                                }}
                                )
                            </div>
                            <div class="wk-cf__popover__actions-link wk-cf__popover__actions-selection-clear" (click)="onClearAll()">
                                {{ "FiltersSidebar.Options.MultiSelect.ClearTitle" | translate }}
                            </div>
                        </div>
                    </div>
                }
                <text-field-pds3 size="medium" class="wk-cf__popover__search">
                    <input type="text" aria-autocomplete="none" [placeholder]="'SearchBar.PlaceHolder' | translate" [formControl]="searchField" />
                </text-field-pds3>
                @if (isMultiSelection() && pagedOptions()) {
                    <div class="wk-cf__popover__list">
                        @for (option of pagedOptions(); track option.value) {
                            <checkbox-field-pds3
                                size="extra-small"
                                [labelFor]="`${fullFilterName()}-${option.value}`"
                                [label]="option.label | wkTranslate"
                            >
                                <input
                                    (change)="onFilterChange(option)"
                                    type="checkbox"
                                    [checked]="isOptionSelected(option)"
                                    [attr.id]="`${fullFilterName()}-${option.value}`"
                                />
                            </checkbox-field-pds3>
                        }
                    </div>
                    @if (maxPageSize() > 1) {
                        <wk-pagination
                            #pagination
                            [itemsCount]="totalItemsCount()"
                            [pageSize]="pageSize()"
                            [firstLastButtons]="false"
                            [currentPage]="pageNumber()"
                            (pageChange)="onPageChange($event)"
                        />
                    }
                }
            </div>
        </popup-pds3>
    </portal-pds3>
}
